// React.lazy and background preload share these imports. Loading a module does
// not mount its page, run effects, or start its polling timers.
const loaders = {
  '/dashboards': () => import('./components/Dashboards'),
  '/chat': () => import('./components/ChatInterface'),
  '/knowledge': () => import('./components/KnowledgeBase'),
  '/agent-connections': () => import('./components/AgentConnections'),
  '/account': () => import('./components/PersonalAccount'),
  '/reports': () => import('./components/Reports'),
  '/evaluations': () => import('./components/Evaluations'),
  '/subscription': () => import('./components/CompanySettings'),
  '/domains': () => import('./components/Domains'),
};
const pending = new Map();
export const preloadPage = path => {
  if (!loaders[path]) return Promise.resolve();
  if (!pending.has(path)) {
    const request = loaders[path]().catch(error => { pending.delete(path); throw error; });
    pending.set(path, request);
  }
  return pending.get(path);
};
export const pagePaths = Object.keys(loaders);
